import * as React from "react";
import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { WipTable } from "@/components/UI/organisms/WipTable/WipTable";
import styles from "./WIPRepairOrders.module.scss";
import { useWorkInProgress } from "@/hooks/WorkInProgress";
import "../../../../helpers/SearchHelpers";
import { RoTotalByInsuranceCompany } from "@/components/UI/organisms/Charts/RoTotalByInsuranceCompany";
import { ProductionStatusCount } from "@/components/UI/organisms/Charts/ProductionStatusCount";

export interface IRepairOrdersProps {}

export function WIPRepairOrders(props: IRepairOrdersProps) {
	const { data: ros, isLoading } = useWorkInProgress();

	return (
		<div className={styles.ros}>
			<PageHead
				pageTitle="Work in Progress Repair Orders"
				pageHead="Work in Progress Repair Orders"></PageHead>
			<div className={styles.chartRow}>
				<div className={styles.chart}>
					<RoTotalByInsuranceCompany loading={isLoading || !ros.length} wipItems={ros} />
				</div>
				<div className={styles.chart}>
					<ProductionStatusCount loading={isLoading || !ros.length} wipItems={ros} />
				</div>
			</div>
			<div className={styles.wipTable}>
				<WipTable
					wipItems={ros}
					loading={isLoading && ros.length === 0}
					emptyMessage="No repair orders"></WipTable>
			</div>
		</div>
	);
}
